//CSS
import './merchantVitals.css';

//Firebase
import 'firebase/functions';
import { functions } from 'firebase';


//REACT
import React, { Component } from 'react';
import { Row, Table } from 'reactstrap';
import { RotateSpinLoader } from 'react-css-loaders';
//Lodash
import _ from 'lodash';

class Vitals extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true
    };
    this.getVitals = this.getVitals.bind(this);
  }

  //Getting vitals
  async getVitals() {
    let vitals;
    let badVitals = [];
    let table = document.getElementById("vitalTable");
    let merchantVitalsFunction = functions().httpsCallable('getMerchantVitals');

    //Shows alert with error message if user is not logged in or admin.
    try {
      vitals = (await merchantVitalsFunction()).data;
    } catch (error) {
      this.setState({
        loading: false
      });
      window.alert(error);
      return;
    }

    _.forEach(vitals, async (id, index) => {
      try {
        if (vitals[index].isOnline === false || vitals[index].batteryPercentage === 0 ||
          vitals[index].health !== "GOOD") {
          badVitals.push(vitals[index]);
        } else {
          var row = table.insertRow(-1);
          var name = row.insertCell(0);
          var online = row.insertCell(1);
          var batteryPercentage = row.insertCell(2);
          var charging = row.insertCell(3);
          var health = row.insertCell(4);
          var volume = row.insertCell(5);
          name.innerHTML = vitals[index].name.bold();
          online.innerHTML = ((vitals[index].isOnline).toString()).toUpperCase().bold().fontcolor("green");
          batteryPercentage.innerHTML = (Math.round(((vitals[index].batteryPercentage) * 100)) + '%')
          charging.innerHTML = vitals[index].isCharging === (true) ? "Yes" : "No";
          health.innerHTML = vitals[index].health === "GOOD" ? "Good" : "Bad";
          volume.innerHTML = ((vitals[index].volume) + '%') +
            ((vitals[index].volume < 20) ? " (low)" :
              (vitals[index].volume > 20 && (vitals[index].volume < 80)) ? " (med)" :
                " (high)")
        }

      } catch (error) {
        console.error(error);
      }
    })
    _.forEach(badVitals, async (id, index) => {
      try {
        var row = table.insertRow(0);
        var name = row.insertCell(0);
        var online = row.insertCell(1);
        var batteryPercentage = row.insertCell(2);
        var charging = row.insertCell(3);
        var health = row.insertCell(4);
        var volume = row.insertCell(5);
        name.innerHTML = badVitals[index].name.bold();
        online.innerHTML = ((badVitals[index].isOnline).toString()).toUpperCase().bold().fontcolor("red");
        batteryPercentage.innerHTML = (Math.round(((badVitals[index].batteryPercentage) * 100)) + '%')
        charging.innerHTML = badVitals[index].isCharging === (true) ? "Yes" : "No";
        health.innerHTML = badVitals[index].health === "GOOD" ? "Good" : "Bad";
        volume.innerHTML = ((badVitals[index].volume) + '%') +
          ((badVitals[index].volume < 20) ? " (low)" :
            (badVitals[index].volume > 20 && (badVitals[index].volume < 80)) ? " (med)" :
              " (high)")
      } catch (error) {
        console.error(error);
      }
    })
    this.setState({
      loading: false
    });
    return;
  }


  componentDidMount() {
    this.getVitals();
  }

  render() {
    return (
      <Row>
        <div>
          <h1> Merchant Vitals </h1>
        </div>
        <br />
        <Table striped="true" hover="true" >
          <div className="loader" >

            <RotateSpinLoader
              color={'#222A5A'}
              size={5}
            />
          </div>
          <thead>
            <tr>
              <th> Merchant Name </th>
              <th> Online </th>
              <th> Battery % </th>
              <th> Charging </th>
              <th> Battery Health </th>
              <th> Volume </th>
            </tr>
          </thead>
          <tbody id="vitalTable" >
          </tbody>
        </Table>
      </Row>
    );
  }
}

export default Vitals;